var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreelancer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 39,
    viewBox: "0 0 20 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.55C12.3359 17.55 14.8158 18.5772 16.6443 20.4057C18.4728 22.2342 19.5 24.7141 19.5 27.3V39H15.6V27.3C15.6001 25.8078 15.03 24.372 14.0063 23.2864C12.9826 22.2007 11.5828 21.5473 10.0932 21.4598L9.75 21.45C8.25784 21.4499 6.82205 22.02 5.73639 23.0437C4.65074 24.0674 3.99729 25.4672 3.90975 26.9568L3.9 27.3V39H0V27.3C0 24.7141 1.02723 22.2342 2.85571 20.4057C4.68419 18.5772 7.16414 17.55 9.75 17.55ZM9.75 0C11.8187 0 13.8026 0.821784 15.2654 2.28457C16.7282 3.74735 17.55 5.73131 17.55 7.8C17.55 9.86869 16.7282 11.8526 15.2654 13.3154C13.8026 14.7782 11.8187 15.6 9.75 15.6C7.68131 15.6 5.69735 14.7782 4.23457 13.3154C2.77178 11.8526 1.95 9.86869 1.95 7.8C1.95 5.73131 2.77178 3.74735 4.23457 2.28457C5.69735 0.821784 7.68131 0 9.75 0ZM9.75 3.9C8.71565 3.9 7.72368 4.31089 6.99228 5.04228C6.26089 5.77368 5.85 6.76566 5.85 7.8C5.85 8.83434 6.26089 9.82633 6.99228 10.5577C7.72368 11.2891 8.71565 11.7 9.75 11.7C10.7843 11.7 11.7763 11.2891 12.5077 10.5577C13.2391 9.82633 13.65 8.83434 13.65 7.8C13.65 6.76566 13.2391 5.77368 12.5077 5.04228C11.7763 4.31089 10.7843 3.9 9.75 3.9Z",
    fill: "#1E4C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancer);
export default __webpack_public_path__ + "static/media/freelancer.34627527.svg";
export { ForwardRef as ReactComponent };